export const projects = [
  {
    id: "old-friends",
    index: "01",
    title: "PRODUCT DESIGN",
    category: "Old Friends — Product Design / Apparel / Art Direction",
    caseCategory: "PRODUCT DESIGN / APPAREL / BRAND / PRODUCTION",
    linkLabel: "VIEW PROJECT",
    layout: "editorial",
    blurb:
      "Apparel, accessories, and physical products developed from concept through production for the independent skate brand Old Friends.",
    intro:
      "From apparel and headwear to accessories and fitness products, I helped develop Old Friends products from initial artwork through production-ready files and finished goods.",
    cardImage: "/images/oldfriends/pt-trio-card.webp",
    cardCaption: "OLD FRIENDS — PT PACK, FITNESS KIT",
    heroImage: "/images/oldfriends/pt-trio-hero.webp",
    frameCaption: "OLD FRIENDS — PT PACK, FITNESS KIT",
    links: [],
    sections: [
      {
        n: "01",
        title: "Apparel & Graphics",
        images: [
          { src: "/images/oldfriends/tom-back.webp", caption: "TOM — BACK GRAPHIC", span: "12" },
          { src: "/images/oldfriends/chicasso-back.webp", caption: "CHICASSO — BACK GRAPHIC", span: "6" },
          { src: "/images/oldfriends/nice-day-back.webp", caption: "HAVE A NICE DAY — BACK GRAPHIC", span: "6" },
          { src: "/images/oldfriends/roses-back.webp", caption: "ROSES — BACK GRAPHIC", span: "6" },
          { src: "/images/oldfriends/legs-back.webp", caption: "LEGS — BACK GRAPHIC", span: "6" },
        ],
      },
      {
        n: "02",
        title: "Headwear & Accessories",
        images: [
          { src: "/images/oldfriends/curb-hat.webp", caption: "CURB — 5-PANEL HAT", span: "12" },
          { src: "/images/oldfriends/cholo-front.webp", caption: "CHOLO — EMBROIDERED CAP", span: "6" },
          { src: "/images/oldfriends/beanie-red.webp", caption: "BEANIE — EMBROIDERED", span: "6" },
          { src: "/images/oldfriends/lipstick-front.webp", caption: "LIPSTICK — FRONT", span: "6" },
          { src: "/images/oldfriends/lipstick-back.webp", caption: "LIPSTICK — BACK, WRAP-AROUND", span: "6" },
          { src: "/images/oldfriends/1900-back.webp", caption: "1-900 — EMBROIDERED BACK HIT", span: "6" },
          { src: "/images/oldfriends/cholo-back.webp", caption: "CHOLO — BACK STAMP", span: "6" },
        ],
      },
      {
        n: "03",
        title: "Product Extensions",
        text: "Old Friends extended beyond clothing into fitness and physical products.",
        images: [
          { src: "/images/oldfriends/pt-pack.webp", caption: "PT PACK — FOAM ROLLER, ROPE & BAND", span: "8c", contain: true },
          { src: "/images/oldfriends/pt-blue.webp", caption: "PT PACK — BLUE", span: "6", contain: true },
          { src: "/images/oldfriends/pt-purple.webp", caption: "PT PACK — PURPLE", span: "6", contain: true },
        ],
      },
      {
        n: "04",
        title: "From Design to Production",
        text: "Production-ready specifications translated artwork, placement, color, and construction details into manufacturer-ready documentation.",
        images: [
          { src: "/images/oldfriends/tech-hippy-skippy.webp", caption: "TECH PACK — HIPPY SKIPPY", span: "6", contain: true },
          { src: "/images/oldfriends/tech-better-together.webp", caption: "TECH PACK — BETTER TOGETHER", span: "6", contain: true },
        ],
      },
      {
        n: "05",
        title: "In the World",
        images: [
          { src: "/images/oldfriends/park-legs.webp", caption: "LEGS TEE — AT THE PARK", span: "12" },
          { src: "/images/oldfriends/abair.webp", caption: "HAVE A NICE DAY — LONG SLEEVE", span: "6" },
          { src: "/images/oldfriends/nice-day-front.webp", caption: "HAVE A NICE DAY — FRONT HIT", span: "6" },
          { src: "/images/oldfriends/fannie-hat.webp", caption: "CAP & SIDE BAG — IN ROTATION", span: "6" },
          { src: "/images/oldfriends/roses-front.webp", caption: "ROSES — FRONT HIT", span: "6" },
        ],
      },
    ],
    capability:
      "CONCEPT • GRAPHIC DESIGN • PRODUCT DESIGN • TECH PACKS • ART DIRECTION • PRODUCTION",
  },
  {
    id: "runrs",
    index: "02",
    title: "RUNRS",
    category: "Brand / Digital / E-commerce",
    year: "2026",
    status: "Live",
    blurb:
      "A community-driven project built around movement.",
    frameCaption: "RUNRS — BRAND / DIGITAL / E-COMMERCE",
    cardImage: "/images/runrs/hero.webp",
    heroImage: "/images/runrs/hero.webp",
    deck: 20,
    deckLabel: "RUNRS — BRAND DECK",
    deckDir: "/images/deck",
    links: [
      { label: "VISIT RUNRS.WORLD", href: "https://runrs.world" },
      { label: "INSTAGRAM", href: "https://www.instagram.com/runrs_/" },
    ],
    overview:
      "RUNRS is an independent brand and digital project built around movement, art, food, family, and culture. What started as a way to bring people together became a full brand system — identity, website, e-commerce, product, and content — designed and run end to end.",
    role: "Founder / Designer. Brand strategy, visual identity, website, e-commerce, product system, photography direction, and ongoing content.",
    problem:
      "Most movement brands are built around a specific sport or performance goal. RUNRS was designed to stay broader — creating one identity for movement, art, food, family, products, and community without turning any one of those things into the whole brand.",
    decisions: [
      "A wordmark and typographic voice rooted in hand-painted sign craft — direct, warm, and built to stretch across apparel, posters, and screens.",
      "Photography-led pages: product, people, and place carry the story instead of heavy interface chrome.",
      "A tight product system — tees, caps, and prints designed as one family, so every drop feels cohesive.",
      "The website doubles as an archive: routes, maps, and gatherings documented alongside the store.",
    ],
    gallery: [
      { src: "/images/runrs/product-3.webp", caption: "PRODUCT — TEE & CAP", span: "6" },
      { src: "/images/runrs/product-1.webp", caption: "PRODUCT — HEADWEAR", span: "6" },
      { src: "/images/runrs/lifestyle-2.webp", caption: "LIFESTYLE — SUNSET MILES", span: "4" },
      { src: "/images/runrs/lifestyle-3.webp", caption: "LIFESTYLE — NEXT GENERATION", span: "4" },
      { src: "/images/runrs/lifestyle-5.webp", caption: "LIFESTYLE — ON THE TRAIL", span: "4" },
      { src: "/images/runrs/product-4.webp", caption: "PRODUCT — HEADWEAR DETAIL", span: "4" },
      { src: "/images/runrs/product-5.webp", caption: "PRODUCT — IN THE FIELD", span: "4" },
      { src: "/images/runrs/lifestyle-4.webp", caption: "LIFESTYLE — CAP, MOUNTAINS", span: "4" },
    ],
    outcome:
      "Live and evolving. New products, routes, and community content continue to ship through runrs.world.",
  },
  {
    id: "streets-of-lisse",
    index: "03",
    title: "STREETS OF LISSÉ",
    category: "UX / Interactive Design",
    year: "2026",
    status: "IN DEVELOPMENT",
    blurb:
      "An interactive map and digital storytelling experience for Walker Ryan’s Streets of Lissé book series.",
    frameCaption: "STREETS OF LISSÉ — INTERACTIVE MAP CONCEPT, IN DEVELOPMENT",
    cardImage: "/images/lisse/hero.webp",
    heroImage: "/images/lisse/hero.webp",
    links: [],
    overview:
      "Streets of Lissé is an interactive map and digital storytelling experience for Walker Ryan’s Streets of Lissé book series — a way to walk the places inside the stories and read them where they happened.",
    role: "UX / Interactive Design — concept, information architecture, interaction design, and the visual system, prototyped in Figma and Framer.",
    problem:
      "The books live as static pages. The opportunity: let readers explore the streets themselves — connecting place, book chapters, and short stories — without turning a reading experience into a noisy map app.",
    decisions: [
      "Map-first information architecture: the streets are the navigation, and each location anchors its own stories.",
      "Book and short-story integration designed as quiet layers over the map, not separate sections to manage.",
      "A restrained visual system — muted cartography, considered type — so the writing stays in front.",
      "Interaction flows prototyped and tested in Figma / Framer before any build begins.",
    ],
    cards: [
      { src: "/images/lisse/lisse-card-tom.png", alt: "Top of Mason — Streets of Lissé book card", href: "https://oldfriendsandco.com/products/top-of-mason-by-walker-ryan" },
      { src: "/images/lisse/lisse-card-hsl.png", alt: "High Street Lows — Streets of Lissé book card", href: "https://oldfriendsandco.com/products/high-street-lows-by-walker-ryan" },
      { src: "/images/lisse/lisse-card-offclark.png", alt: "Off Clark — Streets of Lissé book card", href: "https://oldfriendsandco.com/products/off-clark-by-walker-ryan-presale" },
    ],
    gallery: [],
    outcome:
      "In development. The concept, information architecture, and prototype are in progress — the experience is not yet live.",
  },
  {
    id: "old-friends-fitness",
    index: "04",
    title: "OLD FRIENDS FITNESS",
    category: "Product Design / UX Research",
    blurb:
      "A rehabilitation and fitness experience designed to make programs easier to find, understand, and use.",
    frameCaption: "OLD FRIENDS FITNESS — REHAB & FITNESS PROGRAMS",
    cardImage: "/images/off/hero.webp",
    heroImage: "/images/off/hero.webp",
    links: [],
    overview:
      "Old Friends Fitness is a prototype redesign of the existing rehabilitation and fitness experience — rethinking how programs are found, understood, and used on mobile. The deck above walks through the work.",
    role: "UX Designer — research, information architecture, wireframes, prototyping, and usability testing, completed during my graduate UX work at Arizona State University.",
    year: "2025 — 2026",
    status: "Prototype",
    deck: 6,
    deckLabel: "OLD FRIENDS FITNESS — UX DECK",
    deckDir: "/images/off-deck",
    problem:
      "People following rehabilitation programs struggled to find the right exercises and understand what to do next. Programs were buried in navigation, written in clinical language, and hard to use on a phone mid-session.",
    decisions: [
      "Rebuilt the information architecture around programs and sessions instead of an exercise database.",
      "Accessibility treated as a constraint from the start: type size, contrast, and touch targets designed for real gym and recovery conditions.",
      "Wireframes to clickable prototype, validated through usability testing — iterated on what people actually did, not what they said.",
      "Plain-language content design, so programs read like a coach’s note rather than a chart.",
    ],
    gallery: [],
    outcome:
      "A usability-tested prototype, designed and refined during my graduate UX work. Not publicly launched.",
  },
  {
    id: "sign-painting",
    index: "05",
    title: "SIGN PAINTING",
    category: "Lettering / Environmental Graphics / Craft",
    caseCategory: "SIGN PAINTING / LETTERING / ENVIRONMENTAL GRAPHICS / PRODUCTION",
    linkLabel: "VIEW PROJECT",
    layout: "editorial",
    blurb:
      "Hand-painted signs, lettering, murals, and glass work created using traditional sign-painting techniques.",
    intro:
      "My background in traditional sign painting combines lettering, layout, typography, color, illustration, and physical production across storefronts, walls, glass, and custom signs.",
    cardImage: "/images/signpainting/midtown-detail.webp",
    cardCaption: "MIDTOWN BARBER SHOP — WINDOW LETTERING",
    heroImage: "/images/signpainting/la-hacienda-hero.webp",
    frameCaption: "LA HACIENDA — EXTERIOR LETTERING",
    links: [],
    sections: [
      {
        n: "01",
        title: "Commercial Lettering",
        images: [
          { src: "/images/signpainting/bay-views.webp", caption: "BAY VIEWS — TYPOGRAPHY WALL", span: "6" },
          { src: "/images/signpainting/bar-grill.webp", caption: "BAR & GRILL — EXTERIOR LETTERING", span: "6" },
          { src: "/images/signpainting/food-city.webp", caption: "FOOD CITY — ARCHITECTURAL WALL LETTERING", span: "6" },
          { src: "/images/signpainting/taco-cantina.webp", caption: "TACO CANTINA — EXTERIOR LETTERING", span: "6" },
          { src: "/images/signpainting/iron-ink.webp", caption: "IRON & INK — FASCIA LETTERING", span: "6" },
          { src: "/images/signpainting/donut-bar.webp", caption: "HARVEY'S DONUT BAR — INTERIOR WALL", span: "6" },
        ],
      },
      {
        n: "02",
        title: "Storefronts & Environmental Graphics",
        images: [
          { src: "/images/signpainting/midtown-storefront.webp", caption: "MIDTOWN BARBER SHOP — FULL STOREFRONT", span: "6" },
          { src: "/images/signpainting/midtown-detail.webp", caption: "MIDTOWN BARBER SHOP — WINDOW DETAIL", span: "6" },
          { src: "/images/signpainting/scala-osteria.webp", caption: "SCALA OSTERIA — PAINTED SIGN", span: "12" },
          { src: "/images/signpainting/walk-ins.webp", caption: "WALK-INS WELCOME — VALANCE LETTERING", span: "6" },
          { src: "/images/signpainting/la-tattoo.webp", caption: "LA TATTOO — WINDOW GRAPHICS", span: "6" },
        ],
      },
      {
        n: "03",
        title: "Hand-Painted Signs",
        images: [
          { src: "/images/signpainting/world-peace.webp", caption: "WORLD PEACE — FINISHED MURAL", span: "12" },
          { src: "/images/signpainting/wine-co-mural.webp", caption: "EXTRADIMENSIONAL WINE CO. — INTERIOR MURAL", span: "6" },
          { src: "/images/signpainting/poker-room.webp", caption: "POKER ROOM — VINTAGE HAND-PAINTED SIGNS", span: "6" },
        ],
      },
      {
        n: "04",
        title: "Glass & Personal Work",
        images: [
          { src: "/images/signpainting/demon-mirror.webp", caption: "DEMON — PAINTED MIRROR", span: "6" },
          { src: "/images/signpainting/geisha.webp", caption: "GEISHA — PAINTED GLASS", span: "6" },
          { src: "/images/signpainting/rose-glass.webp", caption: "ROSE — PAINTED GLASS", span: "6" },
          { src: "/images/signpainting/panther.webp", caption: "PANTHER & SNAKE — PAINTED GLASS", span: "6" },
        ],
      },
      {
        n: "05",
        title: "Process & Craft",
        images: [
          { src: "/images/signpainting/brushwork.webp", caption: "BRUSHWORK — IN PROGRESS", span: "6" },
          { src: "/images/signpainting/door-process.webp", caption: "ON-SITE LETTERING — INSTALLATION", span: "6" },
          { src: "/images/signpainting/world-peace-action.webp", caption: "WORLD PEACE — PAINTING ON SITE", span: "12" },
        ],
      },
    ],
    capability:
      "LETTERING • TYPOGRAPHY • SIGN PAINTING • LAYOUT • ILLUSTRATION • COLOR • PRODUCTION",
  },
];

export const getProject = (id) => projects.find((p) => p.id === id);
export const getNextProject = (id) =>
  projects[(projects.findIndex((p) => p.id === id) + 1) % projects.length];
